export interface TreatmentDetails {
  admitDate?: Date;
  dischargeDate?: Date;
  dischargeReason?: string;
  level?: string;
  program?: string;
  relatedInquiry?: string;
  statusDescription?: string;
}

export interface PauseDetails {
  id?: string;
  reason?: string;
  start?: Date;
  end?: Date;
  key: string;
}

export interface RelapsePreventionDetails {
  id?: string;
  start?: Date;
  end?: Date;
}

type TreatmentProgramClient = {
  code: string;
  label: string;
  isDeleted: boolean;
};

export interface TreatmentEpisodeProgramDetails {
  treatmentEpisodeProgramId?: string;
  startDate: string;
  endDate?: string;
  externalId?: string;
  programName?: string;
  treatmentProgramName: string;
  treatmentProgramClient?: TreatmentProgramClient;
}

export const EMPTY_PLACEHOLDER = 'Not set';
